import request from '../request';
const baseUrl = process.env.NODE_ENV !== 'production'
    ? 'license' // 开发环境
    : 'license'; // 生产环境
// export function getCompanyDynamics (params) {
//   return request.post(baseUrl + '/company/companyDynamics/dataList', params)
// }
// 【方案】获取当前已购入的方案和关联数据
export function getSchemeCurrentApi(random) {
    return request.post(baseUrl + '/scheme/current', random);
}
